export default "__VITE_ASSET__BnJfhTeQ__"